var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareFrenchCuff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0752 55.0002C15.3048 42.1622 8.88609 30.8446 3.64902 38.7838C0.27092 45.8786 10.575 51.7907 23.0752 55.0002Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0752 54.999L38.9538 39.1205C29.4942 29.8298 25.9468 20.0323 19.0211 22.7351L4.32495 37.7691C9.05474 31.3501 16.8251 43.8502 23.0752 54.999Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8521 22.7367L33.3793 5",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7844 38.9529L56.3522 21.8918",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4333 37.7696C41.4021 32.1707 43.7626 29.404 48.0754 24.7627C44.469 30.5895 42.3467 33.6632 38.109 38.2764",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8924 46.0491L20.8789 47.0626L23.0748 48.7519L24.933 46.8937L22.737 45.2045L21.8924 46.0491ZM21.8924 46.0491L20.541 44.6978",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0884 47.9043L25.2708 49.0867",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5818 22.7368C24.5295 20.6916 25.9467 19.0206 28.1427 17.8381",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5754 35.5762C37.8159 34.0391 38.8254 32.9754 40.1363 30.6775",
    stroke: "#757575",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareFrenchCuff);
export default __webpack_public_path__ + "static/media/square_french_cuff.54acf29f8de3b98a9cce9f7ab9f58571.svg";
export { ForwardRef as ReactComponent };